import config from '../../../config'
import { EnrolmentFormPersonalData as EnrolmentFormPersonalDataPompeuFabra } from './personaldata.pompeufabra';
import { EnrolmentFormPersonalData as EnrolmentFormPersonalDataArtLaIndustrial} from './personaldata.artlaindustrial';
import { EnrolmentFormPersonalData as EnrolmentFormPersonalDataGeneric } from './personaldata.generic';

export default function EnrolmentFormPersonalData(props)
{
  // console.log("CID 7",config.cid)

  switch(config.cid)
  {
     // Pompeu Fabra
   case 'a8020620': 
   return EnrolmentFormPersonalDataPompeuFabra(props)

     // Art La industrial
   case 'a8042354': 
   return EnrolmentFormPersonalDataArtLaIndustrial(props)

   default: 
   return EnrolmentFormPersonalDataGeneric(props)
  }
}